module.exports = __webpack_public_path__ + "assets/images/key/key_hk_2020.svg?v=09a78f36";